import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

function getTopbarHeight() {
    var topbar = document.querySelector('.js-topbar');
    return topbar ? topbar.getBoundingClientRect().height : 0;
}

function getViewportFix() {
    if (window.visualViewport) {
        return window.visualViewport.offsetTop || 0;
    }
    return 0;
}

function getTargetY(el) {
    return el.getBoundingClientRect().top + window.pageYOffset;
}

function hideNavIfOpen() {
    var nav = document.querySelector('.c-nav');

    if (nav && nav.classList.contains('is-visible')) {
        if (typeof window.hideMenu === 'function') {
            window.hideMenu();
        }
    }
}

function scrollToTarget(selector, offset, smooth) {
    var el = document.querySelector(selector);
    if (!el) return;

    offset = offset ? Number(offset) : 0;

    var topbar = getTopbarHeight();
    var viewportFix = getViewportFix();

    var targetY = getTargetY(el);

    var finalY = targetY - topbar - offset - viewportFix;

    window.scrollTo({
        top: finalY,
        behavior: smooth ? 'smooth' : 'auto'
    });

    hideNavIfOpen();

    // FINAL CORRECTION PASS (klucz dla mobile)
    setTimeout(function () {
        var corrected =
            getTargetY(el) - getTopbarHeight() - offset - getViewportFix();

        window.scrollTo({
            top: corrected,
            behavior: 'auto'
        });

        ScrollTrigger.refresh();
    }, 250);
}

window.runScroll = function (el, offset) {
    scrollToTarget(el, offset, true);
};

function initClicks() {
    var gtt = document.querySelectorAll("[data-target]");
    if (!gtt.length) return;

    for (var i = 0; i < gtt.length; i++) {
        gtt[i].addEventListener('click', function (e) {
            e.preventDefault();

            var target = this.dataset.target;
            var offset = this.dataset.offset || 0;

            if (target === '#wyprobuj') {
                if (this.classList.contains('advice')) {
                    if (window.listComponent) {
                        window.listComponent.setDepartment(true);
                    }
                }
            }

            if (document.querySelector(target)) {
                scrollToTarget(target, offset, true);
            }
        });
    }
}

function handleHashScroll() {
    var hash = window.location.hash;
    if (!hash) return;

    var el = document.querySelector(hash);
    if (!el) return;

    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            scrollToTarget(hash, 0, false);
        });
    });
}

function initScrollSystem() {
    initClicks();

    handleHashScroll();

    window.addEventListener('hashchange', handleHashScroll);
}

window.addEventListener('load', function () {
    initScrollSystem();
});